import {BasicEntity} from '../../framework/message/BasicEntity';

export class UserContext extends BasicEntity {
contextKey: string;
data: Object;
login: string;
range: string;
tabId: string;
vision: string;
widgetId: string;
}

